/* import __COLOCATED_TEMPLATE__ from './lsg-icon-verified-check.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'LSG-c-lsg-icon-verified-check';
const CLASS_NAME_INLINE = `${CLASS_NAME}--inline`;

/**
 * This is the 'verified Check' that you would see on a project digest.
 */
class LsgIconVerifiedCheck extends Component {
   get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.displayInline && CLASS_NAME_INLINE,
    );
  }

  get verifiedText() {
    return this.args.verifiedText ?? 'Verified';
  }
}

export default LsgIconVerifiedCheck;
